import React from "react";
import { Bar, BarChart, CartesianGrid, Label, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import styles from './BarChart.module.css';

const HorizontalMultiBarSimpleChart = ({ graphData, view }) => {

  const barGroupWidth = 120; // Width per bar group (category) - increased for better visibility
  const minWidth = 600; // Minimum chart width
  const chartHeight = 290; // Fixed height for the chart

  // Calculate dynamic width based on number of data points
  const calculatedWidth = Math.max(minWidth, (graphData?.length || 0) * barGroupWidth);

  const CustomLegend = () => {
    const items = [
      { label: 'High', color: '#FFDCC5' },
      { label: 'Medium', color: '#C2E0FF' },
      { label: 'Low', color: '#D9E1E7' },
    ];

    return (
      <div style={{ display: 'flex', gap: 16, fontSize: 12, justifyContent: 'center', marginTop: 10 }}>
        {items.map(item => (
          <div
            key={item.label}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <span
              style={{
                width: 12,
                height: 12,
                borderRadius: 4,
                backgroundColor: item.color,
                display: 'inline-block',
              }}
            />
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    );
  };

  const CustomBarLabel = ({ x, y, width, value }) => {
    return (
        <text
            x={x + width - 5}
            y={y - 3}
            fill="#333"
            textAnchor="end"
            fontSize={10}
            fontWeight={600}
        >
            {value}
        </text>
    );
};

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div
                    style={{
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        padding: '12px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                        minWidth: '200px',
                    }}
                >
                    <p
                        style={{
                            margin: '0 0 8px 0',
                            fontWeight: 600,
                            fontSize: '12px',
                            color: '#333',
                            borderBottom: '1px solid #eee',
                            paddingBottom: '6px',
                        }}
                    >
                        {`${view}: ${label}`}
                    </p>
                    {payload.map((entry, index) => (
                        <div
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                margin: '6px 0',
                                fontSize: '11px',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span
                                    style={{
                                        width: '10px',
                                        height: '10px',
                                        borderRadius: '2px',
                                        backgroundColor: entry.color,
                                        display: 'inline-block',
                                    }}
                                />
                                <span style={{ color: '#666' }}>{entry.name}:</span>
                            </div>
                            <span style={{ fontWeight: 600, color: '#333', marginLeft: '8px' }}>
                                {entry.value}
                            </span>
                        </div>
                    ))}
                </div>
            );
        }
        return null;
    };

  return (
    <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden', paddingBottom: '10px' }}>
      <div style={{ width: calculatedWidth, minHeight: chartHeight }}>
        <ResponsiveContainer width={calculatedWidth} height={chartHeight}>

          <BarChart
            data={graphData}
            layout="horizontal"
            barGap={3}
            barCategoryGap={20}
            margin={{ top: 10 }}
          >
            <XAxis
              dataKey={view === 'Customer Wise' ? 'Customer' : 'DC'}
              type="category"
              angle={0}
              interval={0}
              textAnchor="middle"
              tick={{ fontSize: 12, fontWeight: 500 }}
              height={60}
            />

            <YAxis
              type="number"
              tick={{ fontSize: 10, fontWeight: 600 }}
              tickLine={true}
              interval={0}
              axisLine={true}
            >
              {/* <Label value="No of PO lines" position="insideStart" offset={5} className={styles.axisLabel} /> */}
            </YAxis>
            <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }} />

            <Legend
              verticalAlign="bottom"
              align="center"
              content={<CustomLegend />}
            />
            <Bar dataKey="High" fill="#FFDCC5" radius={[4, 4, 0, 0]} barSize={18} >
              <LabelList content={<CustomBarLabel />} />

            </Bar>
            <Bar dataKey="Medium" fill="#C2E0FF" radius={[4, 4, 0, 0]} barSize={18} >
              <LabelList content={<CustomBarLabel />} />

            </Bar>
            <Bar dataKey="Low" fill="#D9E1E7" radius={[4, 4, 0, 0]} barSize={18} >
              <LabelList content={<CustomBarLabel />} />

            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default HorizontalMultiBarSimpleChart;
